import { units, Typography } from '@hbf/dsl';
import { ManNeutralLight } from '@ha/icons';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { UserEntity } from 'ha/types/UserEntity';
import { OCCUPATION_TRANSLATIONS } from 'ha/constants/Occupation';
import { OCCUPATION } from '@ha/api/v2/types/Occupation';
import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(() => ({
  root: {
    padding: units.yx(0, 1),
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: units.rem(0.75),
    marginRight: units.rem(0.5),
  },
}));

interface Props {
  occupation: UserEntity['occupation'];
}

export const UserCardOccupation: React.FC<Props> = ({ occupation }) => {
  const { classes } = useStyles();
  const { T } = useIntl();
  if (
    !occupation ||
    occupation === OCCUPATION.other ||
    occupation === OCCUPATION.unknown
  ) {
    return null;
  }

  return (
    <Typography.Caption overflow="ellipsis" className={classes.root}>
      <ManNeutralLight className={classes.icon} fontSize="small" />
      {T(OCCUPATION_TRANSLATIONS[occupation])}
    </Typography.Caption>
  );
};
